export default "__VITE_ASSET__AhAbsc2G__"